import React, { useEffect, useRef, useState } from "react";
import { SlidersHorizontal } from "lucide-react";

const SourcesFilter = ({ options, selected, onToggle }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const close = (event) => {
      if (event.type === "keydown" && event.key !== "Escape") return;
      if (event.type === "mousedown" && ref.current?.contains(event.target)) return;
      setOpen(false);
    };
    document.addEventListener("mousedown", close);
    document.addEventListener("keydown", close);
    return () => {
      document.removeEventListener("mousedown", close);
      document.removeEventListener("keydown", close);
    };
  }, [open]);

  if (options.length < 2) return null;
  const count = selected.length;

  return (
    <div className={`results-sources${open ? " is-open" : ""}`} ref={ref}>
      <button
        type="button"
        className="results-sources__button"
        aria-expanded={open}
        aria-controls="results-sources-list"
        onClick={() => setOpen((value) => !value)}
      >
        <SlidersHorizontal size={16} strokeWidth={1.8} aria-hidden="true" />
        Sources
        <span className="results-sources__count">{count === options.length ? "All" : count}</span>
      </button>
      <div className="results-sources__list" id="results-sources-list" role="group" aria-label="Sources">
        {options.map((option) => {
          const on = selected.includes(option.key);
          const last = on && count === 1;
          return (
            <button
              key={option.key}
              type="button"
              className={`results-sources__option${on ? " is-on" : ""}`}
              aria-pressed={on}
              aria-disabled={last || undefined}
              title={last ? "Keep at least one source on" : undefined}
              onClick={() => (last ? null : onToggle(option.key))}
            >
              <span className="results-sources__check" aria-hidden="true" />
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SourcesFilter;
